import React from 'react'
import {QuoteDetailListTable} from "../Component/QuoteDetailListTable";

const BookedTabList = (props) => {
    return (
        <div>
            <QuoteDetailListTable {...props}/>
        </div>
    )
};

export default BookedTabList